// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3X5yn","colMin":"styles_colMin__1Kb9U"};